import { ServiceBase } from '../../../../../core/services/ServiceBase'
import NewsAndSocialProxy from '../proxies/NewsAndSocialProxy'

class NewsAndSocialService extends ServiceBase {
  postBookmark(params) {
    return this.getData(() => NewsAndSocialProxy.postBookmark(params))
  }

  deleteNewsBookmark(params) {
    return this.getData(() => NewsAndSocialProxy.deleteNewsBookmark(params))
  }

  getNewsType(params) {
    return this.getData(() => NewsAndSocialProxy.getNewsType(params))
  }

  getSentiments(params) {
    return this.getData(() => NewsAndSocialProxy.getSentiments(params))
  }

  getNewsAndSocials(params) {
    return this.getData(() => NewsAndSocialProxy.getNewsAndSocials(params))
  }
}

export default new NewsAndSocialService()
